import * as R from 'ramda'
import { BACKEND_URL, get, post } from '../../../../util/api'
import * as type from './type'
import * as selector from './selector'
import { customerLoaded } from '../../../treatment/state/quotation/action'
import Globals from '../../../globals'
import { enrichCommentList } from '../../../process/state/instance-detail/enrich-process-instance'
import { push } from 'connected-react-router'
import { TAB_ACCOUNTING, TAB_FILES, TAB_MEDICAL } from './const'
import * as customerSelector from './selector'

export const findCustomerRequest = (customerId) => ({
    type: type.FIND_CUSTOMER_REQUEST,
    payload: {
        customerId,
    },
})

export const findCustomerSuccess = (customer) => ({
    type: type.FIND_CUSTOMER_SUCCESS,
    payload: {
        customer,
    },
})

export const findCustomerError = (error) => ({
    type: type.FIND_CUSTOMER_ERROR,
    payload: {
        error,
    },
})

export const hydrateCustomerContact = () => ({
    type: type.HYDRATE_CUSTOMER_CONTACT
})

const enrichFile = (state, file) => {
    file.createdByUser = Globals.selector.selectUserDisplayNameById(state, file.createdByUserId)
}

const enrichCustomer = (state, customer) => {
    R.forEach(file => {
        enrichFile(state, file)
    }, customer.scanFileList)
    R.forEach(file => {
        enrichFile(state, file)
    }, customer.implantScanFileList)
    R.forEach(file => {
        enrichFile(state, file)
    }, customer.treatmentPlanFileList)
    R.forEach(file => {
        enrichFile(state, file)
    }, customer.productionFileList)
    R.forEach(file => {
        enrichFile(state, file)
    }, customer.imageList)
    R.forEach(file => {
        enrichFile(state, file)
    }, customer.treatmentPlanPDFList)
}


export const findCustomer = (customerId) => (dispatch, getState) => {
    dispatch(findCustomerRequest(customerId))

    get('/api/customer/find-customer-basic-data?customerId=' + customerId)
        .then(customer => {
            enrichCustomer(getState(), customer)
            dispatch(customerLoaded(customer))
            dispatch(findCustomerSuccess(customer))
        })
        .catch(error => {
            dispatch(findCustomerError(error))
        })
}

export const _changeActiveTab = (tab) => ({
    type: type.CHANGE_ACTIVE_TAB,
    payload: {
        tab,
    },
})

const TAB_PATH_MAPPING = {
    [TAB_ACCOUNTING]: '/api/customer/find-customer-accounting-data?customerId=',
    [TAB_FILES]: '/api/customer/find-customer-file-data?customerId=',
    [TAB_MEDICAL]: '/api/customer/find-customer-medical-data?customerId=',
}

const TAB_TRANSFORMER_MAPPING = {
    [TAB_ACCOUNTING]: (customer, state) => ({
        invoiceList: customer.invoiceList,
        paymentList: customer.paymentList,
    }),
    [TAB_MEDICAL]: (customer, state) => ({
        treatmentPlanList: customer.treatmentPlanList,
        treatmentExecutionList: customer.treatmentExecutionList,
    }),
    [TAB_FILES]: (customer, state) => ({
        scanFileList: customer.scanFileList.map(file => ({
            ...file,
            createdByUser: Globals.selector.selectUserDisplayNameById(state, file.createdByUserId),
        })),
        implantScanFileList: customer.implantScanFileList.map(file => ({
            ...file,
            createdByUser: Globals.selector.selectUserDisplayNameById(state, file.createdByUserId),
        })),
        xRayFileList: customer.xRayFileList.map(file => ({
            ...file,
            createdByUser: Globals.selector.selectUserDisplayNameById(state, file.createdByUserId),
        })),
        cbctFileList: customer.cbctFileList.map(file => ({
            ...file,
            createdByUser: Globals.selector.selectUserDisplayNameById(state, file.createdByUserId),
        })),
        treatmentPlanFileList: customer.treatmentPlanFileList.map(file => ({
            ...file,
            createdByUser: Globals.selector.selectUserDisplayNameById(state, file.createdByUserId),
        })),
        treatmentPlanExternalFileList: customer.treatmentPlanExternalFileList.map(file => ({
            ...file,
            createdByUser: Globals.selector.selectUserDisplayNameById(state, file.createdByUserId),
        })),
        productionFileList: customer.productionFileList.map(file => ({
            ...file,
            createdByUser: Globals.selector.selectUserDisplayNameById(state, file.createdByUserId),
        })),
        conformityDeclarationList: customer.conformityDeclarationList.map(file => ({
            ...file,
            createdByUser: Globals.selector.selectUserDisplayNameById(state, file.createdByUserId),
        })),
        customsInvoiceList: customer.customsInvoiceList.map(file => ({
            ...file,
            createdByUser: Globals.selector.selectUserDisplayNameById(state, file.createdByUserId),
        })),
        otherFileList: customer.otherFileList.map(file => ({
            ...file,
            createdByUser: Globals.selector.selectUserDisplayNameById(state, file.createdByUserId),
        })),
        treatmentPlanPDFList: customer.treatmentPlanPDFList.map(file => ({
            ...file,
            createdByUser: Globals.selector.selectUserDisplayNameById(state, file.createdByUserId),
        })),
    }),
}

const findCustomerPartialRequest = () => ({
    type: type.FIND_CUSTOMER_PARTIAL_REQUEST,
})


export const changeActiveTab = (tab) => (dispatch, getState) => {
    dispatch(_changeActiveTab(tab))

    const path = TAB_PATH_MAPPING[tab]
    const transformer = TAB_TRANSFORMER_MAPPING[tab]
    if (!path || !transformer) {
        return
    }
    dispatch(findCustomerPartialRequest())

    const state = getState()
    const customerId = selector.selectCustomerId(state)

    get(path + customerId)
        .then(customer => {
            const _customer = transformer(customer, getState())
            dispatch(findCustomerSuccess(_customer))
        })
        .catch(error => {
            dispatch(findCustomerError(error))
        })
}


export const uploadCustomerImageRequest = (fileName) => ({
    type: type.UPLOAD_CUSTOMER_IMAGE_REQUEST,
    payload: {
        fileName,
    },
})


export const uploadCustomerImageError = (error, fileName) => ({
    type: type.UPLOAD_CUSTOMER_IMAGE_ERROR,
    payload: {
        error,
        fileName,
    },
})

export const uploadCustomerImageSuccess = (file) => ({
    type: type.UPLOAD_CUSTOMER_IMAGE_SUCCESS,
    payload: {
        file,
    },
})

export const uploadCustomerImage = (fileList, fileName) => (dispatch, getState) => {
    const state = getState()
    const customerId = selector.selectCustomerId(state)
    if (!customerId) {
        return
    }
    dispatch(uploadCustomerImageRequest(fileName))

    const data = new FormData()
    data.append('file', fileList[0])

    fetch(BACKEND_URL + '/api/customer/image-upload-for-customer?customerId=' + customerId + '&fileName=' + fileName, {
        method: 'post',
        body: data,
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    }).then(response => {
        return response.json()
    }).then(file => {
        dispatch(uploadCustomerImageSuccess(file))
    }).catch(error => {
        dispatch(uploadCustomerImageError(error, fileName))
    })
}


export const toggleImageView = () => ({
    type: type.TOGGLE_IMAGE_VIEW,
})


export const fixAccountProblemRequest = () => ({
    type: type.FIX_ACCOUNT_PROBLEM_REQUEST,
})

export const fixAccountProblemSuccess = (accountFix) => ({
    type: type.FIX_ACCOUNT_PROBLEM_SUCCESS,
    payload: {
        accountFix,
    },
})

export const fixAccountProblemError = (error) => ({
    type: type.FIX_ACCOUNT_PROBLEM_ERROR,
    payload: {
        error,
    },
})

export const fixAccountProblem = () => (dispatch, getState) => {
    const state = getState()

    const customer = selector.selectCustomer(state)

    dispatch(fixAccountProblemRequest())

    get('/api/customer/fix-account-problem?email=' + encodeURIComponent(customer.email))
        .then(({ fix }) => {
            dispatch(fixAccountProblemSuccess(fix))
        })
        .catch(error => {
            dispatch(fixAccountProblemError(error))
        })
}


export const startAlignerReproductionRequest = () => ({
    type: type.START_ALIGNER_REPRODUCTION_PROCESS_REQUEST,
})


export const startAlignerReproductionProcessError = (error) => ({
    type: type.START_ALIGNER_REPRODUCTION_PROCESS_ERROR,
    payload: {
        error,
    },
})

export const startAlignerReproductionSuccess = (processInstance) => ({
    type: type.START_ALIGNER_REPRODUCTION_PROCESS_SUCCESS,
    payload: {
        processInstance,
    },
})

export const startAlignerReproductionProcess = () => (dispatch, getState) => {
    const state = getState()
    const customerId = selector.selectCustomerId(state)

    dispatch(startAlignerReproductionRequest())

    get('/api/sales-order/start-aligner-reproduction?customerId=' + customerId)
        .then(processInstance => {
            const taskList = processInstance.processTaskList
            if (taskList.length === 1) {
                const taskId = taskList[0].id
                dispatch(push('/task/detail/' + taskId))
            }

            dispatch(startAlignerReproductionSuccess(processInstance))
        })
        .catch(error => {
            dispatch(startAlignerReproductionProcessError(error))
        })
}

export const startPartialRefundRequest = () => ({
    type: type.START_PARTIAL_REFUND_PROCESS_REQUEST,
})


export const startPartialRefundProcessError = (error) => ({
    type: type.START_PARTIAL_REFUND_PROCESS_ERROR,
    payload: {
        error,
    },
})

export const startPartialRefundSuccess = (customer) => ({
    type: type.START_PARTIAL_REFUND_PROCESS_SUCCESS,
    payload: {
        customer,
    },
})

export const startPartialRefundProcess = () => (dispatch, getState) => {
    const state = getState()
    const customerId = selector.selectCustomerId(state)

    dispatch(startPartialRefundRequest())

    post('/api/sales-order/start-partial-refund-process?customerId=' + customerId)
        .then(customer => {
            dispatch(startPartialRefundSuccess(customer))
        })
        .catch(error => {
            dispatch(startPartialRefundProcessError(error))
        })
}

export const closeResponseFeedbackModal = () => ({
    type: type.CLOSE_RESPONSE_FEEDBACK_MODAL,
})

export const startDownloadCustomerDataError = (error) => ({
    type: type.START_DOWNLOAD_CUSTOMER_DATA_ERROR,
    payload: {
        error,
    },
})

export const startDownloadCustomerDataSuccess = () => ({
    type: type.START_DOWNLOAD_CUSTOMER_DATA_SUCCESS,
})

export const startDownloadCustomerData = () => (dispatch, getState) => {
    const state = getState()
    const customerId = selector.selectCustomerId(state)

    get('/api/security/customer-data-export?customerId=' + customerId)
        .then(() => {
            dispatch(startDownloadCustomerDataSuccess())
        })
        .catch(error => {
            dispatch(startDownloadCustomerDataError(error))
        })
}

export const openDeleteConfirmationModal = () => ({
    type: type.OPEN_DELETE_CONFIRMATION_MODAL,
})

export const closeDeleteConfirmationModal = () => ({
    type: type.CLOSE_DELETE_CONFIRMATION_MODAL,
})

export const showError = () => ({
    type: type.SHOW_ERROR_CONFIRMATION_MODAL,
})

export const handleDeleteConfirmationModal = (value) => ({
    type: type.HANDLE_DELETE_CONFIRMATION_MODAL,
    payload: {
        value,
    },
})

export const deleteCustomerSuccess = (response) => ({
    type: type.DELETE_CUSTOMER_SUCCESS,
    payload: {
        response,
    },
})

export const deleteCustomerError = () => ({
    type: type.DELETE_CUSTOMER_ERROR,
})

export const deleteCustomer = () => (dispatch, getState) => {
    const state = getState()
    const customerId = selector.selectCustomerId(state)

    dispatch(closeDeleteConfirmationModal())

    get('/api/customer/delete-customer-data?customerId=' + customerId)
        .then(response => {
            dispatch(deleteCustomerSuccess(response))
        })
        .catch(() => {
            dispatch(deleteCustomerError())
        })
}

export const startEscalationProcessRequest = () => ({
    type: type.START_ESCALATION_PROCESS_REQUEST,
})


export const startEscalationProcessError = (error) => ({
    type: type.START_ESCALATION_PROCESS_ERROR,
    payload: {
        error,
    },
})

export const startEscalationProcessSuccess = (customer) => ({
    type: type.START_ESCALATION_PROCESS_SUCCESS,
    payload: {
        customer,
    },
})

export const startEscalationProcess = () => (dispatch, getState) => {
    const state = getState()
    const customerId = selector.selectCustomerId(state)

    if (!customerId) {
        return
    }

    dispatch(startEscalationProcessRequest())

    get('/api/sales-order/start-escalation-process?customerId=' + customerId)
        .then(customer => {
            dispatch(startEscalationProcessSuccess(customer))
        })
        .catch(error => {
            dispatch(startEscalationProcessError(error))
        })
}


export const startRefinementSetProcessRequest = () => ({
    type: type.START_REFINEMENT_SET_PROCESS_REQUEST,
})


export const startRefinementSetProcessError = (error) => ({
    type: type.START_REFINEMENT_SET_PROCESS_ERROR,
    payload: {
        error,
    },
})

export const startRefinementSetProcessSuccess = (customer) => ({
    type: type.START_REFINEMENT_SET_PROCESS_SUCCESS,
    payload: {
        customer,
    },
})

export const startRefinementSetProcess = () => (dispatch, getState) => {
    const state = getState()
    const customerId = selector.selectCustomerId(state)

    dispatch(startRefinementSetProcessRequest())

    get('/api/sales-order/start-refinement-set-process?customerId=' + customerId)
        .then(customer => {
            dispatch(startRefinementSetProcessSuccess(customer))
        })
        .catch(error => {
            dispatch(startRefinementSetProcessError(error))
        })
}


export const startRefinementShopProcessRequest = () => ({
    type: type.START_REFINEMENT_SHOP_PROCESS_REQUEST,
})


export const startRefinementShopProcessError = (error) => ({
    type: type.START_REFINEMENT_SHOP_PROCESS_ERROR,
    payload: {
        error,
    },
})

export const startRefinementShopProcessSuccess = (customer) => ({
    type: type.START_REFINEMENT_SHOP_PROCESS_SUCCESS,
    payload: {
        customer,
    },
})

export const startRefinementShopProcess = () => (dispatch, getState) => {
    const state = getState()
    const customerId = selector.selectCustomerId(state)

    dispatch(startRefinementShopProcessRequest())

    get('/api/sales-order/start-refinement-shop-process?customerId=' + customerId)
        .then(customer => {
            dispatch(startRefinementShopProcessSuccess(customer))
        })
        .catch(error => {
            dispatch(startRefinementShopProcessError(error))
        })
}


export const startRetainerRefinementProcessRequest = () => ({
    type: type.START_RETAINER_REFINEMENT_PROCESS_REQUEST,
})


export const startRetainerRefinementProcessError = (error) => ({
    type: type.START_RETAINER_REFINEMENT_PROCESS_ERROR,
    payload: {
        error,
    },
})

export const startRetainerRefinementProcessSuccess = (customer) => ({
    type: type.START_RETAINER_REFINEMENT_PROCESS_SUCCESS,
    payload: {
        customer,
    },
})

export const startRetainerRefinementProcess = () => (dispatch, getState) => {
    const state = getState()
    const customerId = selector.selectCustomerId(state)

    dispatch(startRetainerRefinementProcessRequest())

    get('/api/sales-order/start-retainer-refinement-process?customerId=' + customerId)
        .then(customer => {
            dispatch(startRetainerRefinementProcessSuccess(customer))
        })
        .catch(error => {
            dispatch(startRetainerRefinementProcessError(error))
        })
}


export const changeCustomer = (name, value) => ({
    type: type.CHANGE_CUSTOMER,
    payload: {
        name,
        value,
    },
})

export const changeCustomerContact = (name, value) => ({
    type: type.CHANGE_CUSTOMER_CONTACT,
    payload: {
        name,
        value,
    },
})

export const saveCustomerRequest = () => ({
    type: type.SAVE_CUSTOMER_REQUEST,
})

export const saveCustomerSuccess = (customer) => ({
    type: type.SAVE_CUSTOMER_SUCCESS,
    payload: {
        customer,
    },
})

export const saveCustomerError = (error) => ({
    type: type.SAVE_CUSTOMER_ERROR,
    payload: {
        error,
    },
})

export const reassignPhysician = (physicianId, physicianType) => (dispatch, getState) => {
    const state = getState()

    const { referenceNumber, id } = selector.selectCustomer(state)
    const payload = {
        physicianId,
        physicianType,
        customerReference: referenceNumber,
    }

    post('/api/customer/reassign-physician', payload)
        .then(() => {
            dispatch(findCustomer(id))
        })
        .catch(error => {
            dispatch(findCustomer(id))
        })
}

export const reassignStore = (storeId, customerId) => (dispatch) => {
    const payload = {
        customerId,
        storeId,
    }

    post('/api/customer/reassign-store', payload)
        .then(() => {
            dispatch(findCustomer(customerId))
        })
        .catch(error => {
            dispatch(findCustomer(customerId))
        })
}

export const saveCustomer = () => (dispatch, getState) => {
    const state = getState()
    const hasChanged = selector.selectHasChanged(state)
    if (!hasChanged) {
        return
    }

    dispatch(saveCustomerRequest())

    const customer = selector.selectCustomer(state)
    post('/api/customer/save', customer)
        .then(customer => {
            dispatch(saveCustomerSuccess(customer))
        })
        .catch(error => {
            dispatch(saveCustomerError(error))
        })
}

export const saveCustomerContact = () => (dispatch, getState) => {
    const state = getState()
    const hasChanged = selector.selectHasChanged(state)
    if (!hasChanged) {
        return
    }

    dispatch(saveCustomerRequest())

    const contact = selector.selectCustomerContact(state)
    post('/api/customer/save-contact', contact)
        .then(customer => {
            dispatch(saveCustomerSuccess(customer))
        })
        .catch(error => {
            dispatch(saveCustomerError(error))
        })
        .finally( () => {
            dispatch(hydrateCustomerContact())
        })
}

export const addCustomerFile = (fileType, file) => ({
    type: type.ADD_CUSTOMER_FILE,
    payload: {
        fileType,
        file,
    },
})

export const onFileDeleteFlagSuccess = (fileType, fileId) => ({
    type: type.SET_FILE_DELETE_FLAG,
    payload: {
        fileType,
        fileId,
    },
})

export const openChangeEmailModal = () => ({
    type: type.OPEN_CHANGE_EMAIL_MODAL,
})

export const closeChangeEmailModal = () => ({
    type: type.CLOSE_CHANGE_EMAIL_MODAL,
})

export const changeNewEmail = (name, value) => ({
    type: type.CHANGE_NEW_EMAIL,
    payload: {
        name,
        value,
    },
})

export const changeEmailRequest = () => ({
    type: type.CHANGE_EMAIL_REQUEST,
})

export const changeEmailSuccess = (email) => ({
    type: type.CHANGE_EMAIL_SUCCESS,
    payload: {
        email,
    },
})

export const changeEmailError = () => ({
    type: type.CHANGE_EMAIL_ERROR,
})

export const changeEmail = () => (dispatch, getState) => {
    const state = getState()
    const customerId = selector.selectCustomerId(state)
    const { newEmail } = selector.selectChangeEmailData(state)
    if (!customerId || !newEmail) {
        return
    }
    dispatch(changeEmailRequest())
    post('/api/customer/change-email', {
        customerId,
        email: newEmail,
    })
        .then(response => {
            dispatch(changeEmailSuccess(newEmail))
        })
        .catch(error => {
            dispatch(changeEmailError())
        })
}

export const findProcessCommentRequest = () => ({
    type: type.FIND_PROCESS_COMMENT_REQUEST,
})

export const findProcessCommentSuccess = (processList) => ({
    type: type.FIND_PROCESS_COMMENT_SUCCESS,
    payload: {
        processList,
    },
})

export const findProcessCommentError = (error) => ({
    type: type.FIND_PROCESS_COMMENT_ERROR,
    payload: {
        error,
    },
})

export const findProcessComment = () => (dispatch, getState) => {
    const state = getState()
    const customerId = selector.selectCustomerId(state)
    if (!customerId) {
        return
    }
    dispatch(findProcessCommentRequest())
    get('/api/customer/find-process-comment?customerId=' + customerId)
        .then(processList => {
            const state = getState()
            for (let index = 0; index < processList.length; index++) {
                const process = processList[index]
                enrichCommentList(state, process)
            }

            dispatch(findProcessCommentSuccess(processList))
        })
        .catch(error => {
            dispatch(findProcessCommentError(error))
        })
}

export const saveTreatmentExecutionClarificationCommentRequest = () => ({
    type: type.SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_REQUEST,
})

export const saveTreatmentExecutionClarificationCommentSuccess = (treatmentExecutionList) => ({
    type: type.SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_SUCCESS,
    payload: {
        treatmentExecutionList,
    },
})

export const saveTreatmentExecutionClarificationCommentError = (error) => ({
    type: type.SAVE_TREATMENT_EXECUTION_CLARIFICATION_COMMENT_ERROR,
    payload: {
        error,
    },
})

export const saveTreatmentExecutionClarificationComment = (comment) => (dispatch, getState) => {
    const state = getState()

    const customer = customerSelector.selectCustomer(state)

    const body = {
        customerId: customer.id,
        clarificationComment: comment,
    }

    dispatch(saveTreatmentExecutionClarificationCommentRequest())

    post('/api/treatment/execution/add-clarification-comment', body)
        .then(treatmentExecutionList => {
            dispatch(saveTreatmentExecutionClarificationCommentSuccess(treatmentExecutionList))
        })
        .catch(error => {
            dispatch(saveTreatmentExecutionClarificationCommentError(error))
        })
}

export const changeIsTransferredToDrSmile = (val) => (dispatch, getState) => {
    const state = getState()

    const customer = customerSelector.selectCustomer(state)

    const body = {
        customerId: customer.id,
        drSmileTransfer: val,
    }

    dispatch(updateIsTransferredToDrSmileRequest())

    post('/api/customer/transferred-to-dr-smile', body)
        .then(() => {
            dispatch(updateIsTransferredToDrSmileSuccess(val))
        })
        .catch(error => {
            dispatch(updateIsTransferredToDrSmileError())
        })
}

export const updateIsTransferredToDrSmileRequest = () => ({
    type: type.UPDATE_IS_TRANSFERRED_TO_DR_SMILE_REQUEST,
})

export const updateIsTransferredToDrSmileSuccess = (value) => ({
    type: type.UPDATE_IS_TRANSFERRED_TO_DR_SMILE_SUCCESS,
    payload: {
        value,
    },
})

export const updateIsTransferredToDrSmileError = () => ({
    type: type.UPDATE_IS_TRANSFERRED_TO_DR_SMILE_ERROR,
})

export const updateWhatsappOtpIn = (val) => (dispatch, getState) => {
    if (val === 'null') {
        dispatch(updateWhatsappOtpInNonValidValue())
        return
    }
    const state = getState()

    const customer = customerSelector.selectCustomer(state)

    const valueMap = (val) => {
        return val === 'true' ? '1' : '0'
    }

    const body = {
        customerId: customer.id,
        whatsAppOptIn: valueMap(val),
    }

    dispatch(updateWhatsappOtpInRequest())
    post('/api/customer/update-whatsapp-opt-in', body)
        .then(response => {
            dispatch(updateWhatsappOtpInSuccess(val))
        })
        .catch(error => {
            dispatch(updateWhatsappOtpInError())
        })
}

export const updateWhatsappOtpInRequest = () => ({
    type: type.UPDATE_WHATSAPP_OPT_IN_REQUEST,
})

export const updateWhatsappOtpInSuccess = (value) => ({
    type: type.UPDATE_WHATSAPP_OPT_IN_SUCCESS,
    payload: {
        value,
    },
})

export const updateWhatsappOtpInError = () => ({
    type: type.UPDATE_WHATSAPP_OPT_IN_ERROR,
})

export const updateWhatsappOtpInNonValidValue = () => ({
    type: type.UPDATE_WHATSAPP_OPT_IN_NON_VALID_VALUE,
})



// WEBPACK FOOTER //
// ./src/modules/customer/state/detail/action.js